import moment from 'moment'
import { z } from 'zod'

export const noteSchema = z
	.object({
		note: z.string().refine((data) => data?.length !== 0, {
			message: 'Required',
			path: ['description'],
		}),
		emphasize: z.boolean().optional(),
		reminder: z.boolean().optional(),
		reminderDate: z
			.string()
			.optional()
			.transform((date) =>
				date ? moment(date).format('YYYY-MM-DD') : ''
			),
	})
	.strict()
	.superRefine((data, ctx) => {
		const { reminder, reminderDate } = data

		if (reminder && !reminderDate) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Required',
				path: ['reminderDate'],
			})
		}

		if (
			moment(reminderDate).isValid() &&
			moment(reminderDate).diff(moment().startOf('day')) < 0
		) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Date must be higher or equal to today',
				path: ['reminderDate'],
			})
		}
	})
